import { useMemo } from "react";

interface Acl {
  create?: "yes" | "no";
  delete?: "all" | "own" | "no";
  edit?: "all" | "own" | "no";
  read?: "all" | "own" | "no";
  stream?: "all" | "own" | "no";
}

interface Entity {
  createdById?: string;
}

interface AclPermissions {
  canCreate: boolean;
  canDelete: boolean;
  canEdit: boolean;
  canRead: boolean;
  canStream: boolean;
}

const useAcl = (entityType: string, entity?: Entity | null): AclPermissions => {
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const raw = localStorage.getItem("user");
  const userId = raw ? JSON.parse(raw).id : null;

  return useMemo(() => {
    const acl: Acl = userData?.acl?.table?.[entityType] || {};
    const hasUserId = !!userId;

    return {
      canCreate: acl.create === "yes",
      canDelete:
        hasUserId &&
        (acl.delete === "all" ||
          (acl.delete === "own" && entity?.createdById === userId)),
      canEdit:
        hasUserId &&
        (acl.edit === "all" ||
          (acl.edit === "own" && entity?.createdById === userId)),
      canRead:
        hasUserId &&
        (acl.read === "all" ||
          (acl.read === "own" && entity?.createdById === userId)),
      canStream:
        hasUserId &&
        (acl.stream === "all" ||
          (acl.stream === "own" && entity?.createdById === userId)),
    };
  }, [userData, userId, entityType, entity?.createdById]);
};

export default useAcl;
